import React from "react";
import SEO from "../SEO/SEO.jsx"

const HowItWorks = () => {
  return (
    <div className="middle">
      {/* Adding SEO Meta tags */}
      <SEO
        title={"How WashWoosh Works | Doorstep Car Wash Booking in Jaipur"}
        description={"Learn how easy it is to book a doorstep car wash in Jaipur. Download the WashWoosh app, choose a service, and enjoy expert car cleaning at your location."}
        canonical={"https://washwoosh.com/how-it-works"}
      />
      <div className="about-how-it-works how-it-works ">
        <div className="container">
          <div className="heading-men">
            <h1>How WashWoosh Works?</h1>
            <p className="welcome-text">
            </p>
            <p>The WashWoosh experience is designed to be seamless, efficient, and hassle-free. With <strong className="highlight">simple 5-step process to book a car wash,</strong> you can book a <strong className="highlight">doorstep car cleaning service in Jaipur</strong> using our userfriendly mobile app.</p>
          </div>
          <div className="row pt-4" data-aos="zoom-in" data-aos-duration={3000}>
            <div className="col-lg-4 col-md-4">
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  <div className="how-works-one how-works-active">
                    <img
                      className="img-fluid"
                      src="images/Download-2.svg"
                      alt="Icon"
                    />
                    <h2>
                      <strong className="howitworks-title">
                        Download the App
                      </strong>
                      <br /> Available on both <strong className="howitworks-subtitle">Android</strong> and <strong className="howitworks-subtitle">iOS</strong> platforms.
                    </h2>
                  </div>
                </div>
                <div
                  className="col-lg-12 col-md-12 mobile-marg mt-120"

                >
                  <div className="how-works-one">
                    <img
                      className="img-fluid"
                      src="images/add car_3.svg"
                      alt="Icon"
                    />
                    <h2>
                      <strong className="howitworks-title">Choose a Service</strong>
                      <br />
                      Select from our range of car wash services, including <strong className="howitworks-subtitle">basic exterior
                        wash, complete interior and exterior cleaning,</strong> or our popular <strong className="howitworks-subtitle">quarterly plan</strong>
                    </h2>
                  </div>
                </div>
                <div
                  className="col-lg-12 col-md-12 mobile-marg mt-110"
                >
                  <div className="how-works-one">
                    <img
                      className="img-fluid"
                      src="images/Payment_1_2.svg"
                      alt="Icon"
                    />
                    <h2>
                      <strong className="howitworks-title">Schedule the Wash</strong> <br /> Choose a date and time that fits your schedule.
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-4 modile-box1 position-relative"
            >
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  <div className="how-works-center">
                    <span>1</span>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12">
                  <div className="how-works-center-two">
                    <span>2</span>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12">
                  <div className="how-works-center-three">
                    <span>3</span>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12">
                  <div className="how-works-center-for">
                    <span>4</span>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12">
                  <div className="how-works-center-five">
                    <span>5</span>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12">
                  <div className="how-works-center-six">
                    <span>6</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="row">
                <div
                  className="col-lg-12 col-md-12 mobile-marg mt-150"
                >
                  <div className="how-works-one how-works-rignt">
                    <img
                      className="img-fluid"
                      src="images/Mobile login3.svg"
                      alt="Icon"
                    />
                    <h2>
                      <strong className="howitworks-title">Create Your Profile</strong>
                      <br />
                      Add your vehicle details.
                    </h2>
                  </div>
                </div>
                <div
                  className="col-lg-12 col-md-12 mobile-marg mt-100"
                >
                  <div className="how-works-one how-works-rignt confirm-order">
                    <img
                      className="img-fluid"
                      src="images/Select-bro.svg"
                      alt="Icon"
                    />
                    <h2>
                      <strong className="howitworks-title"> Pick a Location</strong>
                      <br />
                      Enter your preferred location, whether it's your home, office, or any
                      other convenient spot{" "}
                    </h2>
                  </div>
                </div>
                <div
                  className="col-lg-12 col-md-12 mobile-marg mt-100"
                >
                  <div className="how-works-one how-works-rignt ">
                    <img
                      className="img-fluid"
                      src="images/Select-pana.svg"
                      alt="Icon"
                    />
                    <h2>
                      <strong className="howitworks-title"> Relax & Enjoy</strong>
                      <br />
                      Our team of <strong className="howitworks-subtitle">trained car cleaners in Jaipur</strong> arrives at your location,
                      ensuring your vehicle is cleaned to perfection while you focus on your day.
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="heading-men pt-5 pb-0">
            <p>With WashWoosh, getting your car cleaned has never been easier—no more waiting in queues or
              dealing with untrained home cleaners. Experience the convenience of professional <strong className="highlight">doorstep car
                washing services</strong> at your fingertips!</p>
          </div>
        </div>
      </div>
      <div className="At-fingertips-men">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-12 col-md-12"
              data-aos="zoom-in"
              data-aos-duration={2000}
            >
              <div className="At-fingertips-left">
                <div className="heading-men p-0">
                  <img
                    className="app-icon-photo"
                    src="images/app-icon.png"
                    alt="App Icon"
                  />
                  <h2>Download Our App and Enjoy Convenience</h2>
                  <p className="pt-2">
                    Experience the most convenient, professional, and
                    eco-friendly car wash solution—just a tap away!
                  </p>
                  <div className="all-btn">
                    <div className="row mt-4 justify-content-center">
                      <div className="col-lg-2 play">
                        <div className="btn1 btn2">
                          <a href="https://play.google.com/store/apps/details?id=com.washwoosh.userapp&pcampaignid=web_share" aria-label="Download WashWoosh App From Paly Store For Android Users">
                            <img
                              className="img-fluid"
                              src="images/d-app1.png"
                              alt="Play Store Icon"
                            />
                          </a>
                        </div>

                        <div className="btn1 btn2">
                          <a href="https://apps.apple.com/in/app/washwoosh-car-care-app/id6738276020" aria-label="Download WashWoosh App From App Store For ios Users">
                            <img
                              className="img-fluid"
                              src="images/d-app2.png"
                              alt="App Store Icon"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
